import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const KIOSKCARTFUNNELRADIOOPTIONBLOCK_LEGACY_FIELD_ORDER = [
  "label",
  "value"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskCartFunnelRadioOptionBlockDescriptor: _generatedKioskCartFunnelRadioOptionBlockDescriptor,
  kioskCartFunnelRadioOptionBlockBlocDefinition,
  kioskCartFunnelRadioOptionBlockDashboardLayout,
  kioskCartFunnelRadioOptionBlockConfig,
  kioskCartFunnelRadioOptionBlockResolveConfig,
  kioskCartFunnelRadioOptionBlockProperties,
} = doodBlockConfig(
  {
    name: "Kiosk Cart funnel / Choices input / Option item",
    componentType: 'KioskCartFunnelRadioOptionBlockComponent',
    category: 'kiosk',
    description: "Kiosk Cart funnel / Choices input / Option item.",
    keywords: [],
    allowedIn: [
      { bloc: "KioskCartFunnelRadioItemBlockComponent", slot: "options" },
    ],
    sharedFields: {}
  },

  () => ({
    label: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-funnel-radio-option.label.label",
        help: "pages.blocks.kiosk-cart-funnel-radio-option.label.help",
      }
    }),
    value: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-funnel-radio-option.value.label",
        help: "pages.blocks.kiosk-cart-funnel-radio-option.value.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.kiosk-cart-funnel-radio-option.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-cart-funnel-radio-option.fieldset.option.label",
            fields: ["label", "value"],
          },
        ],
      },
    ],
  })
);

export function kioskCartFunnelRadioOptionBlockDescriptor(): IBlockDescriptor;
export function kioskCartFunnelRadioOptionBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskCartFunnelRadioOptionBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskCartFunnelRadioOptionBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskCartFunnelRadioOptionBlockDescriptor, kioskCartFunnelRadioOptionBlockProperties, fieldOrder);
}

export {
  kioskCartFunnelRadioOptionBlockBlocDefinition,
  kioskCartFunnelRadioOptionBlockDashboardLayout,
  kioskCartFunnelRadioOptionBlockProperties,
  kioskCartFunnelRadioOptionBlockConfig,
  kioskCartFunnelRadioOptionBlockResolveConfig,
};

export type KioskCartFunnelRadioOptionBlockConfig = typeof kioskCartFunnelRadioOptionBlockConfig;
